export default __webpack_public_path__ + "static/media/ppi_dark.7f4842c4.png";